export const mediaExtensions = {
    'video': ['avi', 'mov', 'wmv', 'mp4','mkv'],
    'audio': ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'flac'],
    'image': ['jpg', 'jpeg', 'png'],
    'pdf': ['pdf'],
    'link': [],
};

export const buildMediaObject = (mediaList, split = true, extensified = false) => {
    const initAcc = Object.keys(mediaExtensions).reduce((acc, key) => {
        acc[key] = split ? { urls: [], ids: [] } : []; 
        return acc;
    }, {});

    const pushMedia = (acc, x, split) => {
        if (split) {
            acc['urls'].push(x['url']);
            acc['ids'].push(x['id']);
        } else {
            acc.push(x);
        }
    }

    return mediaList.reduce((acc, element) => {
        let itemAdded = false;
        const { incident_media_url: url, incident_media_id: id } = element;
        const itemToAdd = { 'url': url, 'id': id };

        const extension = extensified ? url : url.split('.').pop().toLowerCase();

        for (const [key, value] of Object.entries(mediaExtensions)) {
            if (value.includes(extension)) {
                pushMedia(acc[key], itemToAdd, split);
                itemAdded = true;
                break;
            }
        }

        if (!itemAdded) {
            const isYoutube = url.toUpperCase().includes("YOUTUBE");
            pushMedia(acc[isYoutube ? 'video' : 'link'], itemToAdd, split);
        }
        return acc;
    }, initAcc);
}
